import { render, staticRenderFns } from "./edit-lead.vue?vue&type=template&id=9ccc0ac4&scoped=true"
import script from "./edit-lead.vue?vue&type=script&lang=js"
export * from "./edit-lead.vue?vue&type=script&lang=js"
import style0 from "./edit-lead.vue?vue&type=style&index=0&id=9ccc0ac4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ccc0ac4",
  null
  
)

export default component.exports